// src/components/LeftPanel/LeftFooter.js
import React from 'react';
import useAppStore from '../../contexts/useAppStore';

const LeftFooter = () => {
  const isSidebarOpen = useAppStore((state) => state.isSidebarOpen);

  return (
    <div className="p-4">
      <div className="flex items-start flex-col">
        {isSidebarOpen && (
          <img src="/logo.svg" alt="Logo" className="w-40 h-10 transition-opacity duration-300 ease-in-out opacity-100" />
        )}
        <span className="text-xs italic text-gray-600">Find your way, bee real</span>
      </div>
    </div>
  );
};

export default LeftFooter;
